'use client';

import { UIMarket } from '@drift/common';
import MarketIcon from 'src/components/Utils/MarketIcon';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { BalanceRowData } from './types';

interface BalanceCellProps {
	row: BalanceRowData;
}

export function BalanceCell({ row }: BalanceCellProps) {
	const { spotMarketIndex, netBase, netQuote } = row;
	const uiMarket = UIMarket.createSpotMarket(spotMarketIndex);

	return (
		<div className="flex flex-col gap-y-xs">
			<div className="flex items-center gap-x-xs">
				<MarketIcon
					marketSymbol={uiMarket.uiSymbols.marketDisplaySymbol}
					className="size-lg"
				/>
				<NumberDisplay
					className="text-text-default"
					value={netBase}
					type="number"
					precision="trade"
					isAccountValueToHide
				/>
			</div>
			<div className="typo-b4">
				<NumberDisplay value={netQuote} type="currency" isAccountValueToHide />
			</div>
		</div>
	);
}
